import React from 'react'
//import NewNote from './components/NewNote'
import Results from './components/Results_ho'
//import VisibilityFilter from './components/VisibilityFilter';
import { Container } from 'semantic-ui-react'


const App = (props) => {
  const store = props.store

  return (
    <Container>
      <Results store={store} />
    </Container>
  )
}

//<Series store={store}/> 
//<Togles store={store}/> 
//<VisibilityFilter store={store} />  

export default App